import React from 'react'

import { SVGIcon } from '../../../wrappers/SVGIcon';
import { Icons } from '../../../../data/Assets';

interface IAttachFileProps {
    name: string;
    disablePreview: boolean;
    onPreviewFile: () => void;
    onRemoveFile: () => void;
    onDownloadFile: () => void;
}

const AttachFile = (props: IAttachFileProps) => {
    const { name, disablePreview, onPreviewFile, onRemoveFile, onDownloadFile } = props;
    return (
        <div
            key={name}
            className='immployer__file_management__container__body__files__item'
        >
            <span>{name}</span>
            <div className='immployer__file_management__container__body__files__item__actions'>
                {!disablePreview && (
                    <button
                        className='immployer__file_management__container__body__files__item__actions__preview_btn'
                        onClick={() => onPreviewFile()}
                    >
                        <SVGIcon src={Icons.EyeFill} color='dark_grey' hoverColor='primary' />
                    </button>
                )}
                <button
                    className='immployer__file_management__container__body__files__item__actions__download_btn'
                    onClick={() => onDownloadFile()}
                >
                    <SVGIcon src={Icons.Download} color='dark_grey' hoverColor='primary' />
                </button>
                <button
                    className='immployer__file_management__container__body__files__item__actions__remove_btn'
                    onClick={() => onRemoveFile()}
                >
                    <SVGIcon src={Icons.Trash3Fill} color='dark_grey' hoverColor='error' />
                </button>
            </div>
        </div >
    )
}

export default AttachFile;